/**
 * AlphaSense Agent - Context Engineering Section
 * Section 4: Context Engineering Note
 *
 * Keywords AI Key: ALPHASENSE_CONTEXT_NOTE
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { ALPHASENSE_PROMPT_KEYS } from './variables';
// AlphaSense uses these context prefixes
export const ALPHASENSE_CONTEXT_PREFIXES = [
    'alphasense',
];
class AlphaSenseContextNoteSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = ALPHASENSE_PROMPT_KEYS.contextNote;
        this.fallbackContent = `## Context Engineering

Context items are passed with specific IDs that you must use correctly to link dynamic content.

### Context ID Prefixes

- **as_xxx**: AlphaSense research results (earnings, filings, broker reports)

### Using Context IDs

1. **Reference by ID**: When passing context to sub-agents, use the exact ID
   \`\`\`json
   { "context": ["as_001", "logo_acme"], "purpose": "Research and branding for slide" }
   \`\`\`

2. **Include purpose**: Always explain what the context is for

3. **Group related context**: Put related items in the same context array

4. **Don't fabricate IDs**: Only use IDs returned from tools/searches

### AlphaSense-Specific Context

**Chunk IDs (as_xxx):**
- Each search result chunk gets a unique ID like "as_7x9kf"
- These IDs are stored in global context for later retrieval
- Pass these IDs to other agents via the context parameter

**Using Search Results:**
1. Note the contextId from each chunk in search results
2. Include relevant contextIds in your submitResults call
3. Other agents can retrieve the full content using these IDs

**Context Resolution:**
When you receive resolved context, it means previous searches or data are available.
Use this to avoid redundant searches and build on existing findings.`;
    }
}
const contextNoteSection = new AlphaSenseContextNoteSection();
/**
 * Get the context note section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getContextNoteSection(hasResolvedContext = false) {
    let section = contextNoteSection.getContent();
    if (hasResolvedContext) {
        section += `\n\n**Note:** You have access to previously resolved context. Review it before searching to avoid redundant queries.`;
    }
    return section;
}
/**
 * Export constant for backwards compatibility
 */
export const ALPHASENSE_CONTEXT_NOTE = contextNoteSection.getFallbackContent();
